import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const dictionaries = {
  "es-MX": {
    nav: {
      enterprise: "Empresas B2B",
      segura: "Segura Hub",
      contact: "Contacto",
      contactCta: "Contacto",
    },
    common: {
      languageLabel: "Idioma",
      comingSoon: "Próximamente",
    },
    enterprise: {
      badge: "Protección con Consciencia",
      heroTitle:
        "Investigación y Desarrollo (I+D) aplicado a la Ciberseguridad y la Infraestructura Emergente",
      heroSubcopy:
        "Protect Hub es una firma mexicana de I+D enfocada en ciberseguridad, protección digital y arquitecturas emergentes (Zero Trust, IA adversarial, RAG, Blockchain). Diseñamos investigación aplicada que protege tu empresa, blinda tu infraestructura de nube y eleva el bienestar humano de quienes la usan.",
      ctaPrimary: "Soluciones Hub Enterprise",
      ctaSecondary: "Descubrir Segura Hub",
      indicator1: "Empresas Protegidas",
      indicator2: "Satisfacción",
      whoAreYouTitle: "¿Quién eres tú?",
      whoB2BTitle: "Enfoque para Empresas",
      whoB2BTag: "B2B — Corporativo",
      whoB2BBody:
        "Soluciones enterprise de ciberseguridad, cumplimiento normativo y arquitectura avanzada para proteger tu organización.",
      whoB2BCta: "Explorar servicios",
      whoB2CTitle: "Cyber Life-style para Mujeres",
      whoB2CTag: "B2C — Iniciativa de seguridad y protección",
      whoB2CBody:
        "Herramientas, formación y colectividad para que cada mujer tome control de su seguridad digital y bienestar en línea.",
      whoB2CCta: "Descubrir Segura Hub",
      philosophyEyebrow: "Nuestra Filosofía",
      philosophyTitle: "Nuestra Tríada de Enfoques",
      philosophySub:
        "Tres pilares que se entrelazan para crear un ecosistema digital verdaderamente humano.",
      pillarTechTag: "Protección Avanzada",
      pillarTechTitle: "Tecnología",
      pillarTechBody:
        "Ciberseguridad avanzada que protege tu identidad, datos y privacidad en el entorno digital con tecnología de última generación.",
      pillarPeopleTag: "Bienestar Humano",
      pillarPeopleTitle: "Personas",
      pillarPeopleBody:
        "Bienestar humano integrado con tu seguridad digital. Menos estrés, más control y armonía en tu vida conectada.",
      pillarValuesTag: "Ética Social",
      pillarValuesTitle: "Valores",
      pillarValuesBody:
        "Ética social tejida en cada conexión. Construimos un ecosistema digital más justo, equitativo y seguro para todos/as.",
      founderEyebrow: "Liderazgo y Dirección Técnica",
      founderTitle: "Las mentes detrás del hub",
      founderName: "Brenda Cuevas Vázquez",
      founderCredentials: "Fundadora & Directora Técnica · Ingeniera en Tecnologías y Sistemas de la Información · DevSecOps · IA Ética",
      founderBio:
        "Líder en ingeniería de ciberseguridad con enfoque en \"Security by Design\", DevSecOps y auditoría ética de modelos de Inteligencia Artificial. A través de Protect Hub, coordino la investigación aplicada en arquitecturas complejas y dirijo iniciativas de inclusión digital, construyendo puentes donde la alta tecnología y el bienestar humano coexisten en perfecto equilibrio.",
      founderLinkedinCta: "Conectar en LinkedIn para conocer mi trayectoria",
      founderCollaborateCta: "Colabora con Protect Hub",
      collabModalTitle: "Colabora con Protect Hub",
      collabModalSubtitle: "Únete a nuestra red de profesionales en investigación aplicada en ciberseguridad e IA.",
      collabFieldName: "Nombre completo",
      collabFieldEmail: "Correo electrónico",
      collabFieldArea: "Área de colaboración",
      collabFieldMessage: "Cuéntanos por qué te gustaría colaborar",
      collabFieldCv: "Adjunta tu CV (PDF / DOCX, máx. 3 MB)",
      collabAreas: [
        { value: "investigacion-ia", label: "Investigación Aplicada en Ciberseguridad e IA" },
        { value: "ingenieria-software-seguro", label: "Ingeniería e Implementación de Software Seguro" },
        { value: "auditoria-smart-contracts", label: "Auditoría de Smart Contracts y Blockchain" },
        { value: "gobernanza-datos", label: "Gobernanza de Datos y Privacidad" },
      ],
      collabSubmit: "Enviar candidatura",
      collabSubmitting: "Enviando…",
      collabSuccessTitle: "¡Gracias por tu interés!",
      collabSuccessBody: "Revisaremos tu candidatura y te contactaremos pronto.",
      collabCancel: "Cerrar",
      solutionsEyebrow: "Soluciones Corporativas e Investigación Aplicada",
      solutionsTitle: "Investigación. Ingeniería. Ética.",
      solutionsSub:
        "Un portafolio modular de I+D aplicado que une ciberseguridad de vanguardia con cumplimiento normativo y perspectiva humana.",
      blockATitle: "Diagnóstico y Gobierno",
      blockBTitle: "Ingeniería e Implementación de Software",
      blockCTitle: "Célula de Investigación y Ética Aplicada (I+D)",
      closeCtaTitle: "¿Listo/a para proteger tu empresa?",
      closeCtaBody:
        "Agenda una consultoría gratuita con nuestro equipo de expertos/as.",
      closeCtaButton: "Solicitar Consultoría Hub",
    },
    segura: {
      badge: "Iniciativa de Protect Hub",
      wordmark1: "SEGURA",
      wordmark2: "HUB",
      title: "Segura Hub",
      subtitle:
        "Un ecosistema digital diseñado por y para mujeres que quieren tomar el control de su privacidad, seguridad y bienestar en línea — sin necesitar ser expertas en tecnología.",
      vision:
        "Promovemos la equidad, el cierre de la brecha de género y acercamos la tecnología a grupos subrepresentados mediante herramientas aplicadas e investigación de entorno.",
      ctaPrimary: "Unirme a Segura Hub",
      ctaSecondary: "Explorar Recursos",
      indicator1Value: "+",
      indicator1Label: "Mujeres Formadas",
      indicator2Value: "1",
      indicator2Label: "Iniciativa de Seguridad Digital de Impacto en MX",
      protocolEyebrow: "Protocolo en construcción",
      protocolTitle: "De la iniciativa a la herramienta",
      protocolTitleAccent: "Santuario Digital",
      protocolBody:
        "A través de Segura Hub, diseñamos y estructuramos las bases de Santuario Digital, una arquitectura tecnológica orientada a blindar la identidad de las mujeres en la web.",
      mockupAppName: "Santuario Digital",
      mockupTagline: "Tu escudo personal",
      mockupStatusLabel: "Estado",
      mockupStatusValue: "94% Segura",
      mockupSurvLabel: "Vigilancia Activa",
      mockupSurvValue: "ON",
      mockupAlertsLabel: "Alertas",
      mockupAlertsValue: "0",
      mockupVpnLabel: "VPN de Privacidad",
      mockupVpnValue: "Conectada",
      mockupRecent: "Actividad Reciente",
      mockupRecent1: "Intento de acceso bloqueado",
      mockupRecent2: "Contraseña segura verificada",
      mockupRecent3: "Escaneo de huella digital completo",
      formationEyebrow: "Alfabetización y Formación Práctica",
      formationTitle: "Formación Práctica y Cierre de",
      formationTitleAccent: "Brecha Digital",
      formationIntro:
        "Diseñamos espacios formativos aplicados para públicos reales: emprendedoras, hogares, y mujeres que viven con riesgos digitales específicos.",
      formationCard1Title: "Mujeres Profesionales y Emprendedoras",
      formationCard1Body:
        "Desarrollo de habilidades técnicas para proteger infraestructuras de negocio y datos de clientes.",
      formationCard2Title: "Mujeres en el Hogar y Familias",
      formationCard2Body:
        "Alfabetización en ciberseguridad para mitigar riesgos familiares, control de redes sociales y navegación segura.",
      formationCard3Title: "Atención Especializada frente a Riesgos",
      formationCard3Body:
        "Espacios formativos e interactivos de soporte técnico preventivo para mujeres que han sido víctimas de violencia digital y delitos cibernéticos en la región.",
      badgePresencial: "Encuentros Presenciales",
      badgeOnline: "Talleres Online (Próximamente)",
      agendaCta: "Ver agenda y registro",
      testimonyCta: "Compartir mi historia",
      testimonyTitle: "Comparte tu experiencia",
      testimonySubtitle:
        "Tu testimonio alimenta directamente la investigación del protocolo Santuario Digital. Cuéntanos sobre vulnerabilidades, riesgos, violencia de género o violencia digital que hayas vivido. Tu privacidad está protegida: puedes usar un pseudónimo y nunca compartiremos tus datos sin tu consentimiento.",
      testimonyFieldName: "Nombre o pseudónimo (opcional)",
      testimonyFieldNamePlaceholder: "Puedes dejarlo en blanco o usar un alias",
      testimonyFieldRegion: "Región o país de residencia",
      testimonyFieldRegionPlaceholder: "Ej. CDMX, México · Bogotá, Colombia",
      testimonyFieldTech: "Experiencia o nivel en tecnología",
      testimonyFieldTechPlaceholder: "— Selecciona una opción —",
      testimonyTechLevels: [
        { value: "basico", label: "Básico — uso cotidiano de redes y apps" },
        { value: "intermedio", label: "Intermedio — administro mis cuentas y dispositivos con seguridad" },
        { value: "avanzado", label: "Avanzado — perfil técnico o profesional en TI/seguridad" },
        { value: "ninguno", label: "Prefiero no responder" },
      ],
      testimonyFieldStory: "Tu testimonio",
      testimonyFieldStoryPlaceholder: "Cuéntanos en pocas líneas (mínimo 40 caracteres). Tu historia alimentará la investigación del protocolo Santuario Digital.",
      testimonyConsent:
        "Acepto el tratamiento seguro de mis datos y autorizo el uso anónimo de mi testimonio para alimentar la investigación del protocolo Santuario Digital, bajo los criterios de privacidad de Protect Hub.",
      testimonySubmit: "Compartir mi experiencia",
      testimonyIntroTitle: "Tu voz construye espacios más seguros",
      testimonyIntroBody:
        "En este espacio recopilamos experiencias, riesgos y dinámicas de violencia digital vividas por mujeres. No requerimos tu nombre real ni datos que te pongan en riesgo; tu testimonio es estrictamente confidencial y anónimo. Conocer tu perspectiva y las vulnerabilidades a las que te has enfrentado nos permite recolectar los datos necesarios para alimentar la investigación y la implementación del Protocolo Santuario Digital. Gracias por ayudarnos a mapear y combatir la violencia de género en los entornos virtuales.",
      testimonySubmitting: "Enviando…",
      testimonySuccessTitle: "¡Gracias por compartir!",
      testimonySuccessBody: "Tu historia alimenta la investigación del protocolo Santuario Digital. La revisaremos con el máximo cuidado.",
      testimonyCancel: "Cerrar",
    },
    contact: {
      eyebrow: "Contacto y Colaboración",
      subtitle:
        "Cuéntanos sobre ti y te conectaremos con el equipo y los recursos exactos que necesitas.",
      step1Title: "¿Quién nos contacta?",
      step1B2B: "Soy una Empresa",
      step1B2BSub: "Soluciones enterprise, cumplimiento y arquitectura.",
      step1B2C: "Soy una Mujer",
      step1B2CSub: "Comunidad Segura Hub, recursos y herramientas.",
      step2Title: "¿En qué podemos ayudarte?",
      step2Label: "Tema de interés",
      step3Title: "Cuéntanos más",
      fieldName: "Nombre completo",
      fieldEmail: "Correo electrónico",
      fieldMessage: "Mensaje",
      fieldCollab: "Propuesta de colaboración / co-investigación",
      submit: "Enviar Mensaje",
      submitting: "Enviando...",
      whatsapp: "Contactar por WhatsApp",
      email: "Escríbenos por correo",
      successTitle: "¡Mensaje recibido!",
      successBody: "Te responderemos en menos de 24 horas.",
      errorTitle: "No pudimos enviar tu mensaje",
      errorBody: "Inténtalo de nuevo en un momento.",
      back: "Atrás",
      next: "Continuar",
      consent:
        "Acepto el tratamiento ético de mis datos personales conforme a la LFPDPPP y los principios de privacidad por diseño de Protect Hub.",
      b2bOptions: [
        { value: "ciso-as-a-service", label: "CISO as a Service" },
        { value: "cumplimiento-lfpdppp", label: "Cumplimiento LFPDPPP" },
        { value: "seguridad-devsecops", label: "Seguridad DevSecOps" },
        { value: "arquitectura-avanzada", label: "Arquitectura Avanzada y Security by Design" },
        { value: "implementacion-software-seguridad", label: "Implementación de Software de Seguridad" },
        { value: "auditoria-sesgos-ia", label: "IA Ética y Auditoría de Data Sets" },
        { value: "investigacion-rag-blockchain", label: "Investigación en RAG / Blockchain" },
      ],
      b2cOptions: [
        { value: "santuario-digital-formacion", label: "Santuario Digital / Formación" },
        { value: "colectividad", label: "Iniciativa de seguridad y protección" },
      ],
    },
    footer: {
      tagline: "La privacidad es el nuevo lujo",
      madeWith: "Hecho con consciencia en México",
      sectionsTitle: "Secciones",
      contactTitle: "Contacto",
      legalTitle: "Legal",
      legalPrivacy: "Aviso de Privacidad Integral",
      legalTerms: "Términos y Condiciones de Servicio",
      legalLFPDPPP: "Declaración de Cumplimiento LFPDPPP",
      rights: "Todos los derechos reservados.",
    },
    legal: {
      eyebrow: "Marco Legal y Cumplimiento",
      title: "Documentación Legal",
      subtitle:
        "Toda la documentación de privacidad, términos de servicio y cumplimiento normativo de Protect Hub, conforme a la legislación mexicana vigente.",
      tocTitle: "Índice",
      toc: [
        { id: "aviso-privacidad", label: "Aviso de Privacidad Integral" },
        { id: "terminos-servicio", label: "Términos y Condiciones de Servicio" },
        { id: "cumplimiento-lfpdppp", label: "Declaración de Cumplimiento LFPDPPP" },
      ],
      lastUpdated: "Última actualización: junio de 2026",
    },
  },
};

const LanguageContext = createContext({
  lang: "es-MX",
  setLang: () => {},
  t: (key) => key,
});

function getNested(obj, path) {
  return path.split(".").reduce((acc, part) => (acc == null ? undefined : acc[part]), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("es-MX");
  const t = useCallback(
    (key) => {
      const dict = dictionaries[lang] || dictionaries["es-MX"];
      const value = getNested(dict, key);
      if (value === undefined) return getNested(dictionaries["es-MX"], key) ?? key;
      return value;
    },
    [lang],
  );
  const value = useMemo(
    () => ({ lang, setLang, t, availableLanguages: Object.keys(dictionaries) }),
    [lang, t],
  );
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useT() {
  return useContext(LanguageContext);
}
